import React from 'react';
import { ARCHETYPE_META, ArchetypeIcon } from './NeuralProfile';

/**
 * Compact archetype badge — used in profile cards and scout dashboard rows.
 */
export default function ArchetypeBadge({ archetypeId, archetypeName, size = 'md' }) {
  const meta = ARCHETYPE_META[archetypeId] || { color: '#8b9ab5', icon: '◈' };
  const isLarge = size === 'lg';

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: `${meta.color}18`,
      border: `1px solid ${meta.color}55`,
      borderRadius: 20,
      padding: isLarge ? '6px 14px' : '4px 10px',
      fontSize: isLarge ? 14 : 12,
      fontWeight: 600,
      color: meta.color,
      whiteSpace: 'nowrap',
    }}>
      <ArchetypeIcon archetypeId={archetypeId} size={isLarge ? 16 : 13} />
      {archetypeName}
    </span>
  );
}
